import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingCart, Trash2 } from "lucide-react";
import { useWishlist } from "@/contexts/WishlistContext";
import { useCart } from "@/contexts/CartContext";
import ProductCard from "@/components/product/ProductCard";
import SuggestProductStrip from "@/components/quote/SuggestProductStrip";

export default function Wishlist() {
  const { items, count, clearWishlist } = useWishlist();
  const { addToCart } = useCart();

  const addAllToCart = async () => {
    for (const p of items) {
      // Sequential to keep the local cart state consistent
      // eslint-disable-next-line no-await-in-loop
      await addToCart(p.id, 1);
    }
  };

  if (count === 0) {
    return (
      <main className="dyntra-container py-16 text-center">
        <div className="h-16 w-16 rounded-2xl bg-[#F3EFFC] flex items-center justify-center mx-auto mb-5">
          <Heart className="h-8 w-8 text-[#4B2AAD]" />
        </div>
        <h1 className="font-display text-3xl font-bold text-gray-900">Your wishlist is empty</h1>
        <p className="text-gray-500 mt-2 max-w-md mx-auto">Tap the heart on any product to save it here for later.</p>
        <Link to="/shop" className="dyntra-btn-primary mt-6 inline-flex">Start Shopping</Link>
      </main>
    );
  }

  return (
    <main className="dyntra-container py-10">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-8">
        <div>
          <h1 className="font-display text-3xl font-bold text-gray-900">My Wishlist</h1>
          <p className="text-sm text-gray-500 mt-1">{count} item{count === 1 ? "" : "s"} saved for later</p>
        </div>
        <div className="flex items-center gap-2">
          <button
            data-testid="wishlist-add-all"
            onClick={addAllToCart}
            className="dyntra-btn-primary"
          >
            <ShoppingCart className="h-4 w-4" /> Add all to cart
          </button>
          <button
            data-testid="wishlist-clear"
            onClick={clearWishlist}
            className="inline-flex items-center gap-1.5 rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:border-red-300 hover:text-red-600 transition-colors"
          >
            <Trash2 className="h-4 w-4" /> Clear
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {items.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>

      <SuggestProductStrip variant="minimal" />
    </main>
  );
}
